/* eslint-disable react/no-array-index-key */
import { useLingui } from '@lingui/react/macro'

import { H2 } from '../H2'

import { FaqItem } from './FaqItem'

import FaqStructured from '@/components/Structured/FaqStructured'
import { extractTextNodes } from '@/helpers/extractTextNodes'


import { cls } from 'tagged-classnames-free';
interface IFaqProps {
  className?: string
  h2?: string
  faqList: {
    title: React.ReactNode
    desc: React.ReactNode
  }[]
  isCms?: boolean
}

export const Faq: React.FC<IFaqProps> = (props) => {
  const { t, i18n } = useLingui()

  const { className, h2 = t`FAQS`, faqList, isCms = false } = props
  function replaceMessageValues(
    message: React.ReactNode,
    values?: Record<string, React.ReactNode>,
  ) {
    if (typeof message !== 'string' || !values) {
      return message
    }

    return message.replace(/\{(\w+)\}/g, (_, key: string) => {
      return extractTextNodes(values[key], { translate }).join(' ')
    })
  }

  function translate(descriptor: {
    id: string
    message?: React.ReactNode
    values?: Record<string, React.ReactNode>
  }) {
    const translatedMessage =
      typeof descriptor.message === 'string'
        ? i18n._({ id: descriptor.id, message: descriptor.message })
        : i18n._(descriptor.id)

    return replaceMessageValues(translatedMessage, descriptor.values)
  }

  if (!faqList || faqList.length <= 0) {
    return null
  }

  return (
    <>
      <FaqStructured
        mainEntity={{
          mainEntity: faqList.map((faq) => {
            const desc = extractTextNodes(faq.desc, { translate }).join(' ')
            const title = extractTextNodes(faq.title, { translate }).join(' ')
            return {
              '@type': 'Question',
              'name': title,
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': desc,
              },
            }
          }),
        }}
      />
      <div className={cls`mx-auto max-w-[1056px] px-4 ${className}`}>
        <H2>{h2}</H2>
        <div className='mt-3 space-y-3 md:mt-8 md:space-y-[18px]'>
          {faqList.map((item, index) => {
            return (
              <FaqItem
                key={index}
                isCms={isCms}
                title={item.title}
                desc={item.desc}
              />
            )
          })}
        </div>
      </div>
    </>
  )
}
